var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTesla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 72,
    viewBox: "0 0 77 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 16.086L46.32 7.008C46.32 7.008 59.904 7.278 73.4272 13.17C69.9648 18.078 63.088 20.484 63.088 20.484C62.6208 16.167 59.3952 15.114 49.1552 15.114L38.4 72L27.5808 15.102C17.4048 15.102 14.1792 16.164 13.7088 20.478C13.7088 20.478 6.8416 18.093 3.376 13.188C16.896 7.293 30.48 7.02 30.48 7.02L38.4 16.086L38.3872 16.092H38.4V16.086ZM38.4 4.389C49.328 4.299 61.8432 5.973 74.6496 11.229C76.3616 8.325 76.8 7.044 76.8 7.044C62.8 1.836 49.6896 0.045 38.4 0C27.1104 0.045 14 1.83 0 7.047C0 7.047 0.624 8.622 2.1504 11.235C14.9568 5.967 27.472 4.305 38.4 4.38V4.389Z",
    fill: "#A38150"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesla);
export default __webpack_public_path__ + "static/media/tesla.ca93d4837cc235ddbc833b4e51719810.svg";
export { ForwardRef as ReactComponent };